<div *ngIf="isFlightDeckAdmin && editModeSet" class="section">
  <div class="section__header">
    <h2 class="section__header-text">Event Features <mat-icon *ngIf="editModeSet" (click)="openEditEventFeaturesDialog()" class="edit-icon">edit</mat-icon></h2>
  </div>
  <div class="section__body">
    <div class="event-features__badge-container">
      <app-event-badge *ngIf="isFlightDeckAdmin && aviationEvent.isValidated" [feature]="'validated'" [text]="'Validated'"></app-event-badge>
      <app-event-badge *ngIf="isFlightDeckAdmin && aviationEvent.isFeatured" [feature]="'featured'" [text]="'Featured'"></app-event-badge>
      <app-event-badge *ngIf="aviationEvent.hasAopaPresence" [feature]="'aopapresence'" [text]="'AOPA Presence'"></app-event-badge>
      <app-event-badge *ngIf="aviationEvent.isAopaHosted" [feature]="'aopahosted'" [text]="'AOPA Hosted'"></app-event-badge>
    </div>
  </div>
</div>
